/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.mat-column-Actions[_ngcontent-%COMP%]{text-align:center}.fullwidth[_ngcontent-%COMP%]{max-width:100%}.margin-top[_ngcontent-%COMP%]{margin-top:10px}.margin-bottom[_ngcontent-%COMP%]{margin-bottom:10px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ui/studentcollegerecords/studentcollegerecords.component.css.shim.ngstyle.js.pre-build-optimizer.js